import React from 'react';
import { ConsentConfig, initialiseGDPR } from '@acri-tools/gdpr-library';

export const GDPR_PATH = '/gdpr';
export const PRIVACY_SETTINGS_PATH = '/privacy-settings';

const consentConfig: ConsentConfig = {
    updatedPolicyDate: '2026-09-17T00:00:00Z',
    categories: [
        {
            key: 'necessary',
            label: 'Strictly necessary',
            necessary: true,
            shortDescription: 'Required to remember your privacy choice and to keep you signed in.',
            description: (
                <p>
                    These cookies record that you accepted the personal data policy and keep you signed in.
                    They stay on, because the site cannot store your choice or your session without them.
                </p>
            ),
            cookies: [
                {
                    name: 'gdpr_consent',
                    duration: 'Until you clear site data',
                    description: 'Stores your privacy consent.',
                },
                {
                    name: 'user_token',
                    description: 'Keeps you signed in.',
                },
            ],
        },
        {
            key: 'analytics',
            label: 'Analytics',
            shortDescription: 'Anonymous statistics about visits and pages viewed.',
            description: (
                <p>
                    Optional cookies, such as Google Analytics, measure new visits, return visits and page views.
                    They are not advertising cookies. Refusing them does not block access to the anomaly database.
                </p>
            ),
            cookies: [
                {
                    name: '_ga',
                    duration: '13 months',
                    description: 'Distinguishes visitors for anonymous statistics.',
                },
                {
                    name: '_ga_*',
                    duration: '13 months',
                    description: 'Persists the analytics session.',
                },
            ],
        },
    ],
};

initialiseGDPR(consentConfig, {
    hasAuth: true,
    theme: {
        colour1: '#06a5d6',
        colour2: '#62a7e7',
    },
});
